'use client';
import { useQuery } from '@tanstack/react-query';

import { useSafeLanguage } from '@/contexts/LanguageContext';
import { breakingApi } from '@/services/api';
import type {
  BreakingEventsListParams,
  BreakingNewsCategoriesResponse,
  BreakingNewsCategory,
  BreakingNewsEventsListResponse,
  BreakingNewsMarket,
} from '@/types/breaking.types';

export const BREAKING_QUERY_KEYS = {
  all: ['breaking'] as const,
  categories: (locale: string) => [...BREAKING_QUERY_KEYS.all, 'categories', locale] as const,
  eventsList: (params: BreakingEventsListParams) =>
    [...BREAKING_QUERY_KEYS.all, 'eventsList', params] as const,
};

export const useBreakingCategories = () => {
  const { language } = useSafeLanguage();
  return useQuery<BreakingNewsCategoriesResponse, Error, BreakingNewsCategory[]>({
    queryKey: BREAKING_QUERY_KEYS.categories(language.code),
    queryFn: () => breakingApi.getBreakingCategories(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    select: (response) => response.data,
  });
};

export const useBreakingEventsList = (params: BreakingEventsListParams) => {
  return useQuery<BreakingNewsEventsListResponse, Error, BreakingNewsMarket[]>({
    queryKey: BREAKING_QUERY_KEYS.eventsList(params),
    queryFn: () => breakingApi.getBreakingEventsList(params),
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    select: (response) => response.data,
  });
};
